export const paymentMethods = [
  { label: "Tarjeta de crédito", value: "credit" },
  { label: "Tarjeta de débito", value: "debit" },
  { label: "Transferencia", value: "transfer" },
  { label: "Efectivo", value: "cash" },
  { label: "Otro", value: "other" },
];
